import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2Status } from '@/api/model/interfaces';

export default class PackageKS2StatusOdata extends OdataManager<PackageKS2Status> {}
